import { render, staticRenderFns } from "./lineDesc.vue?vue&type=template&id=38d31896&scoped=true"
import script from "./lineDesc.vue?vue&type=script&lang=js"
export * from "./lineDesc.vue?vue&type=script&lang=js"
import style0 from "./lineDesc.vue?vue&type=style&index=0&id=38d31896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d31896",
  null
  
)

export default component.exports